import React, { Component } from 'react'
import './css/index.css'
import Navbar from '../../components/navbar'
import Footer from '../../components/footer'
import Banner2 from '../../assets/image/banner-homepage-3.jpg'
// import Banner2 from '../../assets/image/banner-homepage-3.jpg'
import {Button} from '@material-ui/core'
import Banner from '../../components/tribe/tribe_banner3'
import GridService from '../../components/tribe/tribe_services'
import GridEvent from '../../components/grid/grid2'
import gallery1 from '../../assets/image/gallery1.jpg'
import gallery2 from '../../assets/image/gallery2.jpg'
import gallery3 from '../../assets/image/insight3.jpg'
import no_image from '../../assets/image/no_image.png'
import Event from '../../components/grid/event'
import Gallery from '../../components/grid/gallery'
import Bulletin from '../../components/grid/bulletin'
import Event1 from '../../assets/image/event1.jpg'
import Event2 from '../../assets/image/event2.jpg'
import Event3 from '../../assets/image/event3.jpg'
import Grid from '../../components/grid/grid2'
import {data_bulletin} from '.././../dummy/data'
import {data_event} from '.././../dummy/data_event'
// import Event from '../../components/grid/event'

import megaseminar from '../../assets/image/event-management/mega-seminar.jpg'
import customefamily from '../../assets/image/event-management/customer-family.jpg'
import corporatemeeting from '../../assets/image/event-management/corporate-meeting.jpg'
import eventmanagement from '../../assets/image/event-management/event-management.jpg'
import productlaunch from '../../assets/image/event-management/product-launch.jpg'
import speaker from '../../assets/image/event-management/speaker.jpg'
import themecustome from '../../assets/image/event-management/theme-custome.jpg'

import corpu from '../../assets/image/event/corpu/corpu_cover.jpg'
import hr from '../../assets/image/event/hr_4.0/hr_cover.jpg'
import ramcharam from '../../assets/image/event/ram/ram_cover.jpg'
import {connect} from 'react-redux'
import {getEvent} from '../../redux/action/event'
import Skeleton  from 'react-loading-skeleton';
import chrpe_inclass from '../../assets/image/event/chrpe_inclass.jpg'
import csep_inclass from '../../assets/image/event/csep_inclass.jpg'
import csep from '../../assets/image/cover-website-csep.jpg'
import Ram from '../../assets/image/event/ram/ram_cover.jpg'
import Cptm from '../../assets/image/event/cptm/cptm_cover.jpg'
import paul from '../../assets/image/event/paul.jpg'
import {getBanner,getCaption} from '../../redux/action/home'
import ReactGA from 'react-ga';
import {TRACKING_ID} from '../../service/base_url'
let data_services=[
    {
        title:"Mega Seminar, Public Seminar, & Workshop",
        content:"We help you define your objectives, actualize your vision, and become your partner in managing your competency enhancement event.",
        img:megaseminar,
        link:'/services/eventmanagement/megaseminar'
    },
    {
        title:"Customer & Family Gathering, Team Building",
        content:"Whether planning a grand event or intimate gathering, we will supervise from site selection, theme development, menu selection, invitations, registrations, and executions.",
        img:customefamily,
        link:'/services/eventmanagement/customerbuilding'
    },
    {
        title:"Product Launches",
        content:"We save your time and provide creative ideas to introduce new products, customize unique solutions and manage all your event details.",
        img:productlaunch,
        link:'/services/eventmanagement/productlaunch'
    },
    {
        title:"Corporate Meeting & Conference",
        content:"Special events with creative concepts & various themes. We provide superior services with details to create first-class events for large and small groups.",
        img:corporatemeeting,
        link:'/services/eventmanagement/corporatemeeting'
    },
    {
        title:"Artist / Speaker Management & Entertainment",
        content:"We manage all your requirements for hosting conferences and seminars.",
        img:speaker,
        link:'/services/eventmanagement/artist'
    },
    {
        title:"Themed and Custom Event",
        content:"Our experienced team has expertise in the industry and our valued network can deliver professional services.",
        img:themecustome,
        link:'/services/eventmanagement/themeevvent'
    }
]
class index extends Component {
    state={
        event:[],
        webinar:[]
    }
    componentDidMount(){
        this.props.getBanner()
        this.props.getCaption()
        ReactGA.initialize(TRACKING_ID);
        ReactGA.pageview(window.location.pathname);
    }

    // componentWillReceiveProps(newProps){
    //     const {list_event}=newProps.event
    //     let webinar=[],event=[]
    //     if(list_event!==null){
    //         list_event.map((data,i)=>{
    //             if(data.webEvent.categoryId===1||data.webEvent.categoryId===2){
    //                 event.push(data)
    //             }else{
    //                 console.log('test', data)
    //                 webinar.push(data)
    //             }
    //         })
    //         this.setState({event:webinar})
    //     }
    // }
    loader=()=>{
        return(
            <div className='loader-skeleton'>
                <Skeleton height={200}/>
                <Skeleton height={200}/>
                <Skeleton height={200}/>
            </div>
        )
    }
    render() {
        // const image=[
        //     // {image:paul},
        //     // {image:csep_inclass},/
        //     {image:chrpe_inclass},
        //     // {image:csep},
        //     // {image:newcorpu},
        //     // {image:Banner1},
        //     {image:Ram},
        //     // {image:Chrpe},
        //     {image:Cptm},
        //     // {image:Rise},
        // ]
        
        const {event,webinar}=this.state
        const {general,home,welcome,welcomeNote}=this.props
        const new_image=[]
        home.banner.map((data)=>{
            new_image.push(data)
        })
        return (
            <div>
                <Navbar/>
                <br/><br/><br/><br/><br className='hide-mobile'/><br className='hide-mobile'/>
                <section className='event-management'>
                   <Banner bread_crum={['Event Management','']} image={new_image} title="We create meaningful & memorable event" subtitle="We help you define your objectives, actualize your vision, and become your partner in managing your competency enhancement event."/>
                   
                   <br/><br/><br/>
                   <div className='event-management-content' >
                       <Event jumlah={3}/>
                        {/* <div style={{display:'flex',justifyContent:'space-between'}}>
                            <div className='success-story'>                        
                                <h2>Event & Webinar</h2>
                                &nbsp;&nbsp;&nbsp;
                                <div className='hide-mobile' style={{width:1,height:40,backgroundColor:'grey'}}></div>
                                &nbsp;&nbsp;&nbsp;
                                <p className='hide-mobile'>Join with us</p>
                            </div>
                            <div>
                                <Button size='small' style={{textTransform:'none',fontWeight:'bold',zIndex:1}} color="primary" onClick={()=>window.location.assign('/event-list')}>More Event</Button>
                            </div>
                        </div>
                        <br/><br/>
                        {general.isLoading?this.loader():<GridEvent data={event}/>} */}
                        <br/><br/><br/>
                        <h2>Our Services</h2>
                        <br/><br/>
                        <GridService data={data_services} is_footer={false}/>
                        <br/><br/><br/>
                        <div className='buletin'>
                            <div style={{display:'flex',justifyContent:'space-between'}}>
                                <div className='success-story'>                        
                                    <h2>Knowledge Capital Bulletin </h2>
                                    &nbsp;&nbsp;&nbsp;
                                    <div  style={{width:1,height:40,backgroundColor:'grey'}}></div>
                                    &nbsp;&nbsp;&nbsp;
                                    <p className='hide-mobile'>Check out our latest thinking</p>
                                </div>
                                <div>
                                    <Button style={{textTransform:'none',fontWeight:'bold'}} color="primary" onClick={()=>window.location.assign('/publication/bulletin')}>More bulletin </Button>
                                </div>
                            </div>
                            <br/><br/>
                            {/* <div className='grid-bulletin'>
                                <div><img src={Event1} style={{width:'100%'}}/></div>
                                <div><img src={Event1} style={{width:'100%'}}/></div>
                                <div><img src={Event1} style={{width:'100%'}}/></div>
                                <div><img src={Event1} style={{width:'100%'}}/></div>
                            </div> */}
                            <Bulletin data={data_bulletin}/>
                        </div>
                        <br/><br/>
                        {/* <div className='gallery'>
                            <div style={{display:'flex',justifyContent:'space-between'}}>
                                <div style={{display:'flex',alignItems:'center',justifyContent:'flex-start'}}>                        
                                    <h2>Event gallery </h2>
                                    &nbsp;&nbsp;&nbsp;
                                    <div style={{width:1,height:40,backgroundColor:'grey'}}></div>
                                    &nbsp;&nbsp;&nbsp;
                                    <p>See the piece memories of our greatest event</p>
                                </div>
                                <div>
                                    <Button style={{textTransform:'none',fontWeight:'bold'}} color="primary" onClick={()=>window.location.assign('/event')}>More gallery </Button>
                                </div>
                            </div>
                            <br/><br/>
                            <Gallery image={data_gallery}/>

                        </div> */}
                   </div>
                </section>
                <br/><br/>
                <Footer/>
            </div>
        )
    }
}
const mapStateToProps=(state)=>({
    general:state.general,
    event:state.event,
    home:state.home
})
const mapDispatchToProps={
    getEvent,
    getBanner,
    getCaption
}
export default connect(mapStateToProps,mapDispatchToProps)(index)